import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

export async function apiGet(path) {
  const { data } = await http.get(path);
  return data;
}

export async function apiPost(path, body) {
  const { data } = await http.post(path, body ?? {});
  return data;
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong. Please try again.";
}

export const money = (cents, currency = "usd") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format((cents || 0) / 100);

export const dateFmt = (v) =>
  v ? new Date(v).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const timeFmt = (v) =>
  v ? new Date(v).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "To be confirmed";

export const safeUrl = (v) => {
  try {
    const u = new URL(v);
    return ["https:", "http:"].includes(u.protocol) ? u.href : "#";
  } catch {
    return "#";
  }
};

// Resolve media URLs (/api/media/..) against the backend origin.
export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND}${u}`;
  return u;
};
